import { createFileRoute, Navigate } from "@tanstack/react-router";
import { PageContainer, PageHeader } from "@/components/layout/page";
import { EmptyState } from "@/components/feedback/states";

export const Route = createFileRoute("/_app/executions/$runId")({
  validateSearch: (s: Record<string, unknown>): { pipelineId?: string } =>
    typeof s.pipelineId === "string" ? { pipelineId: s.pipelineId } : {},
  component: ExecutionRedirect,
});

function ExecutionRedirect() {
  const { runId } = Route.useParams();
  const { pipelineId } = Route.useSearch();

  if (pipelineId) {
    return (
      <Navigate to="/pipelines/$pipelineId/runs/$runId" params={{ pipelineId, runId }} replace />
    );
  }
  return (
    <PageContainer>
      <PageHeader title="Run detail" />
      <EmptyState
        title="Open this run from its pipeline"
        description="Run details live under the pipeline that produced them."
      />
    </PageContainer>
  );
}
